import { Col, ColType, Crud, CrudOption, CrudApi } from "../../comp/crud";
import {
    ApiClient,
    displayRepaymentPlanStatus, getRepaymentPlanStatusOpt, displayPaidMethod, getPaidMethodOpt
} from "../../api/ApiClient";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Typography,
    Image,
    Tag,
    Button,
    Descriptions,
    Row,
    Tooltip,
    Toast,
    Popover
} from '@douyinfe/semi-ui';
import { IconBarChartHStroked, IconCoinMoneyStroked, IconHelpCircle } from "@douyinfe/semi-icons";
import { formatAmountZhCn, formatDate, renderPlatformTooltip, renderStatDetailContentPlan, renderRepaymentPlanStatusTag,renderPeriodNo } from "../../utils";
import dayjs from "dayjs";
import { Col as RowCol } from "@douyinfe/semi-ui/lib/es/grid";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export interface OutMoneyPlanProps {
    leadId?: number;
    leadName?: string;
    outMoneyUserId?: string;
    platform?: string;
    leadCity?: string;

}
export default function OutMoneyPlan(props: OutMoneyPlanProps) {

    const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
    const crudApiRef = useRef<CrudApi>();
    const filterFormRef = useRef<any>();

    const [statData, setStatData] = useState([] as any[]);
    const [statDataObj, setStatDataObj] = useState({} as any);

    const [filterLeadId, setFilterLeadId] = useState(true);
    const [filterLeadName, setFilterLeadName] = useState(true);
    const [filterOutMoneyUserId, setFilterOutMoneyUserId] = useState(true);
    const [filterPlatform, setFilterPlatform] = useState(true);
    const [filterLeadCity, setFilterLeadCity] = useState(true);

    const getLoanStatusOpt = (): CrudOption[] => {
        let items = [
            {
                label: "全部",
                value: "",
                key: "0",
            },
            {
                label: "贷款中",
                value: "LOANING",
                key: "1",
            },
            {
                label: "已坏账",
                value: "BAD_DEPT",
                key: "2",
            },
            {
                label: "已释放",
                value: "SETTLED",
                key: "3",
            },
        ];
        return items;
    };

    const renderInterestDesc = (text: string, row: any) => {
        let detail = row.planInterestDetail;
        if (!detail) {
            return '-'
        }
        else if (!detail.interestStartDate) {

            return (
                <>
                    <span></span><Tag>{detail.interestAmount} * {detail.interestRate} </Tag>
                </>
            );
        } else {
            return (
                <>
                    <span>{formatDate(detail.interestStartDate)}至{formatDate(detail.interestEndDate)}({detail.interestEndDateDesc}) </span><Tag>{detail.interestAmount} * {detail.interestRate} * {detail.interestDays}天</Tag>
                </>
            );
        }

    };



    let cols: Col[] = [
        {
            name: "贷款状态",
            key: "loanStatus",
            colFilterSort: 0,
            showInFilter: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.SELECT,
            getOptions: () => Promise.resolve(getLoanStatusOpt()),
        },
        {
            name: "ID",
            key: "id",
            hideInEdit: true,
            hideInCreate: true,
            hideInList: true,
            type: ColType.NUMBER
        },

        {
            name: "客户ID",
            key: "leadId",
            width: 90,
            showInFilter: filterLeadId,
            type: ColType.NUMBER,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "客户姓名",
            key: "leadName",
            width: 90,
            type: ColType.STRING,
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: filterLeadName,
            render: (value, record, index) => {
                return (
                    <>
                    <Tooltip content={<div>按揭专员: {record.agentName}<br/>销售: {record.saleName}</div>}>
                    <Typography.Text
                        link
                        type="primary"
                        onClick={() => openMortgageLoanModal(record.leadId,record.leadName)}
                    >
                        {value}({record.leadId})
                    </Typography.Text>
                    </Tooltip>
                    </>
                );

            },

        },
        {
            name: "城市",
            key: "leadCity",
            width: 60,
            type: ColType.SELECT,
            getOptions: () => apiClient.getDictAsOpts("city"),
            hideInEdit: true,
            hideInCreate: true,
            showInFilter: filterLeadCity,

        },

        {
            name: "按揭专员ID",
            key: "agentId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "按揭专员",
            key: "agentName",
            width: 90,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "销售ID",
            key: "saleId",
            type: ColType.STRING,
            showInFilter: false,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
        },
        {
            name: "销售",
            key: "saleName",
            width: 80,
            type: ColType.STRING,
            showInFilter: true,
            hideInCreate: true,
            hideInEdit: true,
            hideInList: true,
        },
        {
            name: "贷款平台",
            key: "platform",
            width: 160,
            type: ColType.STRING,
            showInFilter: filterPlatform,
            hideInCreate: true,
            hideInEdit: true,
            render: (text: any, record: any) => (
                            <Tooltip style={{maxWidth:350}} content={renderPlatformTooltip(record)}>
                                <Typography.Text mark>{text || "-"}</Typography.Text>
                                
                            </Tooltip>
                          ),
        },
        {
                                          name: "期数",
                                          key: "periodNo",
                                          width: 70,
                                          type: ColType.STRING,
                                          // 期数渲染: 手动创建的(蓝Tag)、客户自还的(橙Tag)、系统生成的(纯文本)
                                          render: renderPeriodNo
                                        },
                                       
                                        {
                                          name: "还款日期",
                                          key: "dueDate",
                                          width: 90,
                                          type: ColType.DATE_RANGE,     // 日期范围筛选，筛选时转为 "startDate,endDate"
                                          showInFilter: true,
                                          defaultSortOrder: false,
                                        },
                                     
    

       
        {
            name: "出款金额",
            key: "expense",
            width: 90,
            type: ColType.NUMBER,
            render: (value, record, index) => {
                return (
                   
                        <span>{formatAmountZhCn(record.loanHelpRepaymentPlanAmount+record.cardHelpRepaymentPlanAmount
                            +record.borrowAmount
                        )}</span>
                   
                );
            },
        },
        {
                            name: "信用卡代过账",
                            key: "postingHelpAmount",
                            width: 90,
                            type: ColType.NUMBER,
                            hideInList: false,
                            render: (a) => formatAmountZhCn(a),
                        },
        
        
        {
            name: "出款人",
            key: "paidUserName",
            width: 80,
            type: ColType.STRING,
            hideInCreate: true,
            render: (value, record, index) => {
                if (record.loanType == 'BORROW') {
                    return (
                        <Text>{record.borrowerName}</Text>
                    );
                } else {
                    return (
                        <Text>{record.paidUserName}</Text>
                    );
                }
            },
        },
        {
            name: "出款人",
            key: "outMoneyUserName",
            width: 80,
            type: ColType.STRING,
            showInFilter: filterOutMoneyUserId,
            hideInList: true,

        },
        {
            name: "出款日期",
            key: "paidDate",
            width: 110,
            type: ColType.DATE_RANGE,
            hideInCreate: true,
            showInFilter: true,
            defaultSortOrder: "descend",
            render: (value, record, index) => {
                if (record.loanType == 'BORROW') {
                    return (
                        <Text>{record.borrowDate}</Text>
                    );
                } else {
                    return (
                        <Text>{record.paidDate}</Text>
                    );
                }
            },
        },
        {
              name: "还款图片",
              key: "imageUrls",
              width: 70,
              type: ColType.STRING,
              hideInCreate: true,
              render: (value, record, index) => {
                      if(value){
                         return    ( <Image
                                  width={50}
                                  height={50}
                                  src={record.imageUrls && record.imageUrls.length > 0 ? record.imageUrls[0].url : ''}
                                  preview={{
                                      src: (record.imageUrls || []).map(item => item.url)
                                  }}
                              /> )
                                }else {
                                  return '';
                                }
                    } 
            },
        
        {
            name: "还款方式",
            key: "paidMethod",
            width: 100,
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            render: (a) => displayPaidMethod(a),
            getOptions: (row) => Promise.resolve(getPaidMethodOpt())
        },
        {
            name: '利息',
            key: 'interestAmount',
            width: 70,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: (value: number) => (
                <Text type="warning">
                    {formatAmountZhCn(value || 0)}
                </Text>
            )
        },
        {
            name: '利息计算',
            key: 'interestAmount',
            width: 160,
            type: ColType.TEXT,
            showInFilter: false,
            hideInEdit: true,
            hideInCreate: true,
            render: renderInterestDesc
        },
         {
            name: "贷款金额",
            key: "amount",
            width: 90,
            type: ColType.NUMBER,
            hideInList: true,
            render: (a) => formatAmountZhCn(a),
        },
        {
            name: "还款天数",
            key: "paidDays",
            width: 90,
            type: ColType.NUMBER,
            hideInCreate: true,
        },
        {
              name: "日利率",
              key: "interest",
              width: 60,
              type: ColType.STRING,
              render: (value, record, index) => {
                            return (
                                <Tooltip style={{maxWidth: 450}} content={<div>
                                    贷款利率: {record.interest }<br/>
                                    信用卡利率: {record.borrowInterest}<br/>
                                    借款利率: {record.postingInterest }<br/>
                                   
                                </div>}>
                                    <Typography.Text mark>{value}</Typography.Text>
                                </Tooltip>
                            );
                        },
            },
        {
            name: "贷款编号",
            key: "loanNo",
            type: ColType.STRING,
            showInFilter: true,
            hideInList: true,
            hideInCreate: true,
            hideInEdit: true,
            width: 110,
        },

        {
            name: "状态",
            key: "status",
            width: 70,
            render: (value, record, index) => renderRepaymentPlanStatusTag(value, record),
            type: ColType.SELECT,
            showInFilter: true,
            hideInEdit: true,
            hideInCreate: true,
            getOptions: (row) => Promise.resolve(getRepaymentPlanStatusOpt())
        },

    ]



    //打开详情
    const detailAction = (a: any) => {
        const w = window.open("about:blank");
        let queryParams = {
            ...crudApi?.getQueryParams(),
            type: 'all'
        }
        if (w != null) {
            //获取表格data的id列表
            const ids = crudApi?.getData()?.map((i) => i.leadId);
            const data = {
                id: a.leadId,
                ids: ids,
                viewMode: true,
                visitMode: false,
                leadFrom: 'report',
                queryParams: queryParams,
            };
            w.location.href =
                "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
        }
    };

    // 功能12: 打开贷款详情页面
  // 跳转到新窗口 /#/newleadLoan，传入客户ID和姓名
  // 对应二级页面 indexMortgageLoan.tsx (entityKey: mortgageLoan/listGroupPlatform)
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

    let nowDate = new Date();
    //计算nowDate的所在月份的第一天和最后一天
    let startDate = new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1);
    let endDate = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
    const [initFilterValues, setInitFilterValues] = useState({
        paidDate: [startDate, endDate],
    });
    let startDateStr = formatDate(startDate);
    let endDateStr = formatDate(endDate);
    const initParams = {
        paidDate: startDateStr + "," + endDateStr,
    };

    useEffect(() => {
        if (props.leadId) {
            setFilterLeadId(false);
        }
        if (props.leadName && props.leadName != "") {
            setFilterLeadName(false);
        }
        if (props.outMoneyUserId && props.outMoneyUserId != "") {
            setFilterOutMoneyUserId(false);
        }
        if (props.platform && props.platform != "") {
            setFilterPlatform(false);
        }
        if (props.leadCity && props.leadCity != "") {
            setFilterLeadCity(false);
        }

        //刷新统计
        initStatCountData();
    }, [statDataObj]);

    const queryStatCount = async (data: any) => {
        let params = {
            ...data,
        };
        console.log("统计报表查询参数：", params);
        apiClient.request("/repaymentPlan/listPaidSum", "GET", data).then((resp) => {
            setStatDataObj(resp.data);
        });
    };

    const initStatCountData = async () => {
        console.log("统计报表返回数据：", statDataObj);
        if (!statDataObj) {
            return;
        }

        const data = [
            { key: "", value: "汇总" },
            {
                key: "借贷金额",
                value: formatAmountZhCn(statDataObj.amount),
            },

           
           {
                           key:"代过账金额",
                           value: formatAmountZhCn(statDataObj.cardHelpPostingPlanAmount )
           
                       },
            {
                key: (
                    <Tooltip
                        style={{ maxWidth: 400 }}
                        content={"出款金额 = 贷款代还 + 信用卡代还 + 借款金额"}
                    >出款金额
                        <IconHelpCircle
                            style={{
                                color: "#E91E63",
                            }}
                        />
                    </Tooltip>
                ),
                value: formatAmountZhCn(statDataObj.loanHelpRepaymentPlanAmount + statDataObj.cardHelpRepaymentPlanAmount  + statDataObj.borrowAmount)

            },
            {
                key: "个人借款金额",
                value: formatAmountZhCn(statDataObj.borrowAmount)

            },
            {
                key: "个人借款已还",
                value: formatAmountZhCn(statDataObj.borrowReturnAmount),

            },
             {
                key: (
                    <Tooltip
                        style={{ maxWidth: 400 }}
                        content={"支出合计 = 贷款代还 + 信用卡代还  + 个人借款 - 个人借款已还"}
                    >支出合计
                        <IconHelpCircle
                            style={{
                                color: "#E91E63",
                            }}
                        />
                    </Tooltip>
                ),
                value: <span
                    style={{
                        color: "#E91E63",
                    }}
                >{formatAmountZhCn(statDataObj.paidAmount)}</span>

            },
           

        ];
        setStatData(data);
    };



    const listSumStat = () => {
        const style = {
            boxShadow: "var(--semi-shadow-elevated)",
            backgroundColor: "var(--semi-color-bg-2)",
            borderRadius: "4px",
            padding: "10px",
            margin: "auto",
        };
        return (
            <div style={{ display: "flex", width: "100%", margin: "5px", alignItems: "center" }}>
                <Popover
                    content={renderStatDetailContentPlan(statDataObj)}
                    trigger="hover"
                    position="bottomLeft"
                    showArrow
                >
                    <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked style={{marginRight: 4}}/>统计详情</a>
                </Popover>
                <Descriptions data={statData} row style={style} />
            </div>
        );
    };

    const applyQuickDate = (startDate: Date, endDate: Date) => {
        const api = crudApiRef.current;
        if (!api) { Toast.info('页面加载中，请稍后再试'); return; }
        const formApi = filterFormRef.current;
        if (formApi) formApi.setValue('paidDate', [startDate, endDate]);
        api.refresh();
    };

    const PaidDateQuickButtons = () => {
        const today = new Date();
        const nearDays = [
            { label: '近3天', days: 3 },
            { label: '近7天', days: 7 },
            { label: '近15天', days: 15 },
        ];
        const months = Array.from({ length: 5 }, (_, i) => {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            return {
                label: `${d.getMonth() + 1}月`,
                start: new Date(d.getFullYear(), d.getMonth(), 1),
                end: new Date(d.getFullYear(), d.getMonth() + 1, 0),
            };
        });
        return (
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', margin: '4px 0 2px', flexWrap: 'wrap' }}>
                <span style={{ color: 'var(--semi-color-text-2)', fontSize: 12, fontWeight: 500 }}>出款日期:</span>
                {nearDays.map(item => {
                    const s = new Date(today); s.setDate(s.getDate() - item.days);
                    return <Button key={item.label} size="small" theme="light" onClick={() => applyQuickDate(s, today)}>{item.label}</Button>;
                })}
                <span style={{ color: '#ddd', margin: '0 2px' }}>|</span>
                {months.map(item => (
                    <Button key={item.label} size="small" theme="light" onClick={() => applyQuickDate(item.start, item.end)}>{item.label}</Button>
                ))}
            </div>
        );
    };

    return <>

        <Row>
            <RowCol span={24}>{listSumStat()}</RowCol>
        </Row>
        <PaidDateQuickButtons />
        <Crud
            getCrudApi={(api) => { setCrudApi(api); crudApiRef.current = api; }}
            getFilterFormApi={(_crudApi, formApi) => { filterFormRef.current = formApi; }}
            canUpdate={false}
            canCreate={false}
            canDelete={false}
            canExport={true}
            params={{
                loanStatus:"SETTLED"
            }}
            select={false}
            name="出款明细"
            entityKey="repaymentPlan/listPaid"
            pageSize={50}
            rowActionWidth={0}
            fetchDataAfterMethod={queryStatCount}
            cols={cols}
        />

    </>
}